// Google Analytics tracking ID
export const GA_TRACKING_ID = "G-2S5QFMZZK3"

// Initialize Google Analytics
export const initGA = () => {
  if (typeof window === "undefined") {
    return
  }

  // Check if gtag is already initialized
  if (window.gtag && window.dataLayer) {
    return
  }

  // Initialize dataLayer
  window.dataLayer = window.dataLayer || []
  function gtag() {
    window.dataLayer.push(arguments)
  }
  window.gtag = gtag

  // Load the gtag script
  const script = document.createElement("script")
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`
  document.head.appendChild(script)

  // Configure gtag after script loads
  script.onload = () => {
    gtag("js", new Date())
    gtag("config", GA_TRACKING_ID, {
      anonymize_ip: true,
    })
  }
}

// Disable Google Analytics (if it was already loaded)
export const disableGA = () => {
  if (typeof window === "undefined" || !window.gtag) {
    return
  }

  // Set consent to denied
  if (window.gtag) {
    window.gtag("consent", "update", {
      analytics_storage: "denied",
      ad_storage: "denied",
    })
  }
}

// Check cookie consent and initialize/disable GA accordingly
export const checkCookieConsent = () => {
  if (typeof window === "undefined") {
    return
  }

  const cookieConsent = localStorage.getItem("cookieConsent")
  
  if (cookieConsent === "accepted") {
    initGA()
  }
}

